import Vue from "vue";
import VueRouter from "vue-router";
import Silverdor from "../views/Silverdor.vue";


Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Silverdor
  },
 
  
  
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});



export default router;
